const byHosts = {};

const defaults = {
  VUE_APP_API_URL: process.env.VUE_APP_API_URL,
  VUE_APP_GOOGLE_CLIENT_ID: process.env.VUE_APP_GOOGLE_CLIENT_ID,
};

byHosts['test.tagline.mediasoft.team'] = {
  VUE_APP_API_URL: '//test.api.tagline.mediasoft.team',
  VUE_APP_GOOGLE_CLIENT_ID: '1059408172888',
};

byHosts['tagline.mediasoft.team'] = {
  VUE_APP_API_URL: '//api.tagline.mediasoft.team',
  VUE_APP_GOOGLE_CLIENT_ID: '1059408172888',
};

const config = byHosts[document.location.host] || defaults;
export default {
  VUE_APP_API_URL: config.VUE_APP_API_URL,
  VUE_APP_GOOGLE_CLIENT_ID: config.VUE_APP_GOOGLE_CLIENT_ID,
};
